import { render, staticRenderFns } from "./FormularioCtrlFormulariosComponent.vue?vue&type=template&id=44b6a1ae"
import script from "./FormularioCtrlFormulariosComponent.vue?vue&type=script&lang=js"
export * from "./FormularioCtrlFormulariosComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports